export function buildLeadsFilterLocalStorageKey(
  view: "LIST" | "PIPELINE",
  userId: string,
  routeId: string,
) {
  return `lead-${view}-filter-${userId}-${routeId}`;
}
